export enum RouteActionTypes {
    SET_ROUTES = "SET_ROUTES",
    CLEAR_ROUTES = "CLEAR_ROUTES"
}